import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import axios from "axios";

class   ShoolfeeInvoiceList extends Component{
 
    state = {
        check : false,
        isModal : false,
        schoolfees : [],
    }
    async getSchoolfee(){
         await axios.post("schoolfeesList", {
                    id: this.props.formData
                } ).then((response) => {
               this.setState({
                schoolfees : response.data
            })
        })
    }

    edit=()=>  {
        this.getSchoolfee()
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    Print_ = () =>{
        let invoices = window.open("", "_blank", "width=600,height=300")
        let text =  ""
        let Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']
        this.state.schoolfees.forEach((invoice) => {
            text += `${ invoice?.student?.sectionclass?.section?.establishment?.name  }\n`
            text += `_________________\n`
            text += `Adress : ${ invoice?.student?.sectionclass?.section?.establishment?.other_adress }\n`
            text += `Télé : ${ invoice?.student?.sectionclass?.section?.establishment?.tel }\n`
            text += `Email : ${ invoice?.student?.sectionclass?.section?.establishment?.email }\n`
            text += `.................\n\n`
            text += `Matr. ID : ${ invoice?.student?.matricule }\n`
            text += `Eleve : ${ (invoice?.student?.user?.last_name || '') } ${ (invoice?.student?.user?.family_name || '') } ${ (invoice?.student?.user?.first_name || '') }\n`
            // text += `Parent : ${ (invoice?.student?.user?.user?.last_name  || '') } ${ (invoice?.student?.user?.user?.family_name  || '') } ${ (invoice?.student?.user?.user?.first_name  || '') }\n`
            // text += `Télé : ${ (invoice?.student?.user?.user?.tel  || '') }\n`
            text += `_________________\n`
            text += ` \tRECU N°. ${ invoice?.invoice }\n \n`
            
            text += `Année scolaire : ${ invoice?.year?.year }\n`
            text += `Section/option : ${ invoice?.student?.sectionclass?.section?.entitled_section }\n`
            text += `Classe : ${ invoice?.student?.sectionclass?.class?.short_entitled_class } ${ invoice?.student?.sectionclass?.title}\n\n`

            text += `La somme de : ${ invoice?.pay_mount + "" + invoice?.sectionschoolfeecategory?.currency }\n`
            text += `Motif : ${ invoice?.sectionschoolfeecategory?.schoolfeecategory?.category } ${ (invoice?.sectionschoolfeecategory?.transport?.axe || "") }\n`
            text += `Echéance : ${ ( invoice?.trimesectschool?.trimester?.short_trimester  || invoice?.month?.month) }\n`
            text += `Payé le : ${ new Date(invoice?.createdAt)?.getDate() } ${ Months[new Date(invoice?.createdAt)?.getMonth()]} ${ new Date(invoice?.createdAt)?.getFullYear() } ${ new Date(invoice?.createdAt)?.getHours() }h:${ new Date(invoice?.createdAt)?.getMinutes() }\n`
            text += invoice?.remaining_amount > 0 ? `Dette ${  invoice?.trimesectschool?.trimester?.short_trimester || invoice?.month?.month }: ${ invoice?.remaining_amount + "" + invoice?.sectionschoolfeecategory?.currency}\n` : ``
            text += invoice?.dette > 0 ? `Dette totale: ${ invoice?.dette + "" + invoice?.sectionschoolfeecategory?.currency}\n` : ``
            
            text += `------------------\n`
            text += `Par : ${ (invoice?.staff?.user?.last_name  || '') } ${ (invoice?.staff?.user?.family_name  || '') }\n`
            
            text += `Merci et bienvenue encore\n`
            text += `Print ${ new Date()?.toLocaleDateString("en-GB") } ${ new Date()?.getHours() }h:${ new Date()?.getMinutes() }`
            text += `\n©By Evive Digital\n\n`
        })
        invoices.document.write(`<pre>${ text }</pre>`)
        invoices.document.close()
        invoices.print()
    }
    
    checkbox = () => {
        this.setState({
            check: !this.state.check
        }); 
    }
    render(){
        var profile = JSON.parse(localStorage.getItem('profile'))
        const establishment = profile?.profile?.establishment || {};
        const isCompact = this.state.check;
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="schoolfee-invoice-dialog"
                contentClassName="schoolfee-invoice-modal"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header className="schoolfee-invoice-header">
                    <div className="schoolfee-invoice-title">
                        <span><FeatherIcon icon="file-text" size="20" /></span>
                        <div>
                            <small>Recus imprimables</small>
                            <Modal.Title>Factures de paiement</Modal.Title>
                        </div>
                    </div>
                    {this.state.schoolfees.length > 0 && <b>{this.state.schoolfees.length} recu(s)</b>}
                </Modal.Header>
                    <Modal.Body className="schoolfee-invoice-body">
                        <div ref={el => (this.componentRef = el)}>
                        {
                            this.state.schoolfees.map((invoice) => {
                                const studentName = `${ invoice.student.user.last_name } ${invoice.student.user.family_name ? invoice.student.user.family_name : "" } ${invoice.student.user.first_name ? invoice.student.user.first_name : "" }`;
                                const className = `${invoice.student.sectionclass.class.short_entitled_class} ${invoice.student.sectionclass.title}`;
                                const period = invoice?.trimesectschool?.trimester?.short_trimester || invoice?.month?.month;
                                const currency = invoice?.sectionschoolfeecategory?.currency || "";
                                const category = invoice?.sectionschoolfeecategory?.schoolfeecategory?.category || "";
                                const transport = invoice?.sectionschoolfeecategory?.transport?.axe || "";
                                const paidDate = new Date(invoice.createdAt)?.toLocaleDateString("en-GB");

                                return (
                                    <div className={isCompact ? "schoolfee-invoice-receipt is-compact mb-3" : "schoolfee-invoice-receipt mb-3"} key={invoice.id || invoice.invoice}>
                                        <div className="schoolfee-invoice-receipt__head">
                                            {establishment.logo ? <img src={establishment.logo} alt="" /> : null}
                                            <div>
                                                <strong>{ establishment.name}</strong>
                                                <span>{ establishment.city}</span>
                                                <span>Tel : { establishment.tel} {establishment.email ? ` | Email : ${establishment.email}` : ""}</span>
                                            </div>
                                        </div>

                                        <div className="schoolfee-invoice-receipt__title">
                                            <span>Recu No</span>
                                            <strong>{invoice.invoice}</strong>
                                        </div>

                                        <div className="schoolfee-invoice-receipt__meta">
                                            <div><span>Annee scolaire</span><strong>{invoice.year.year}</strong></div>
                                            <div><span>Classe</span><strong>{className}</strong></div>
                                            <div><span>Section/option</span><strong>{invoice.student.sectionclass.section.entitled_section}</strong></div>
                                            <div><span>Date de paiement</span><strong>{paidDate}</strong></div>
                                        </div>

                                        <div className="schoolfee-invoice-receipt__text">
                                            <p>Recu de <strong>{studentName}</strong></p>
                                            <p>La somme de <strong>{ invoice.pay_mount + "" + currency}</strong></p>
                                            {invoice?.remaining_amount > 0 ? <p>Dette {period} : <strong>{ invoice?.remaining_amount + "" + currency}</strong></p>: null}
                                            {invoice?.dette > 0 ? <p>Dette totale : <strong>{ invoice?.dette + "" + currency}</strong></p>: null}
                                            <p>Motif : <strong>{category + " " + transport +" echeance de " + period}</strong></p>
                                        </div>

                                        <div className="schoolfee-invoice-receipt__sign">
                                            <span>Pour l'etablissement</span>
                                            <strong>{ invoice.staff.user.last_name+ " " + invoice.staff.user.first_name}</strong>
                                            <small>{ establishment.city}, le { new Date()?.toLocaleDateString("en-GB") }</small>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="schoolfee-invoice-footer">
                        <label className="schoolfee-invoice-check" htmlFor="check"><input type={"checkbox"} onClick={() => this.checkbox()} id="check" /> Format compact</label>
                        <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <button onClick={() => this.Print_()} className="btn btn-outline-primary btn-sm"><FeatherIcon icon="printer" size="20"></FeatherIcon> POS</button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </Modal.Footer>
            </Modal>
            
        </div>
        )
    }
}
export default ShoolfeeInvoiceList;

